import { call, put, all, takeLatest } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import { get } from 'lodash';

import * as actions from './actions';
import * as types from '../types';

import axiosAdmin from '../../../services/axiosAdmin';
import { applyTheme } from '../../../config/themes';

function* loginRequest({ payload }) {
  try {
    const response = yield call(axiosAdmin.post, '/usuario/autenticar', payload);

    axiosAdmin.defaults.headers.Authorization = `Bearer ${response.data.token}`;

    const email = get(response, 'data.user.email', payload.email);
    let corTema = 'emerald';
    let posicaoBarra = 'top';

    if (email) {
      try {
        const temaResponse = yield call(axiosAdmin.get, `/tema/${encodeURIComponent(email)}`);
        corTema = get(temaResponse, 'data.cor', 'emerald') || 'emerald';
        const posicaoSalva = get(temaResponse, 'data.posicaoBarra');
        posicaoBarra = ['side', 'side-collapsed'].includes(posicaoSalva) ? posicaoSalva : 'top';
      } catch {
        corTema = 'emerald';
        posicaoBarra = 'top';
      }
    }

    applyTheme(corTema);
    document.documentElement.setAttribute('data-navigation-position', posicaoBarra);

    yield put(actions.loginSucess({ ...response.data, corTema, posicaoBarra }));

    // toast.success('Login realizado com sucesso');

  } catch (error) {
    // console.log('error: ', error);
    toast.error('Usuário ou senha inválido');

    yield put(actions.loginFailure());
  }
}

function persistRehydrate({ payload }) {
  const token = get(payload, 'auth.token');
  const corTema = get(payload, 'auth.corTema', 'emerald');
  const posicaoSalva = get(payload, 'auth.posicaoBarra');
  const posicaoBarra = ['side', 'side-collapsed'].includes(posicaoSalva) ? posicaoSalva : 'top';

  if (!token) return;

  axiosAdmin.defaults.headers.Authorization = `Bearer ${token}`;
  applyTheme(corTema);
  document.documentElement.setAttribute('data-navigation-position', posicaoBarra);
}

export default all([
  takeLatest(types.LOGIN_REQUEST, loginRequest),
  takeLatest(types.PERSIST_REHYDRATE, persistRehydrate),
]);

